import React from 'react';

import { getBanner } from 'models/banner';
import { fetchNews } from 'models/news';
import { replaceRoute, routeChange } from 'models/routing';
import { fetchHomeModels } from 'models/ownership';
import { logout, setIsWebview, setLogin, setAuthChecking, exchangeSSOTicket } from 'models/auth';
import { getUserProcess } from 'models/user';
import storage from 'util/storage';

import LoginRoute from './Login';
import SignupRoute from './Signup';
import ResetRoute from './Reset';
import VerifyRoute from './Verify';
import VesShareRoute from './VesShare';
import OwnerShipRoute from './OwnerShip';
import MemberRoute from './Member';
import CheckRoute from './Check';
import NewsRoute from './News';
import AfterSalesRoute from './AfterSales';
import DisclaimerRoute from './Disclaimer';
import PrivacyRoute from './Privacy';
import MembershipTermsRoute from './MembershipTerms';
import RegulationRoute from './Regulation';
import FaqRoute from './Faq';
import ShopRoute from './Shop';
import WebViewRoute from './WebView';
import NotSupportRoute from './NotSupport';
import TestDrivePrivacyPreviewRoute from './TestDrivePrivacyPreview';
import AppointmentRoute from './Appointment';

let timeoutId;
const routes = {
	path: '/',
	components: () => [],
	render: (_, children) => children,
	onEnter: async ({ next, store }) => {
		const isIE = false || !!document.documentMode;
		if (isIE) {
			store.dispatch(replaceRoute({ pathname: '/notSupport' }));
		}

		const { routing, auth } = store.getState();
		if (routing.search.includes('src=app')) {
			store.dispatch(setIsWebview(true));
		}

		/*
		 * SSO ticket exchange（App WebView 登入）
		 * 要在 Webview 延續 App 的登入狀態，App 會在開啟 WebView 時帶入 SSO ticket（透過 query string），前端需要將 ticket 送到後端驗證並交換成 Session Cookie
		 * 驗證成功後，前端會刪除 URL 中的 ticket 參數，避免重複驗證
		 */
		if (auth.isAuthChecking) {
			const urlParams = new URLSearchParams(routing.search);
			const ticket = urlParams.get('ticket');

			if (ticket) {
				await store.dispatch(exchangeSSOTicket(ticket));
				const cleanedParams = new URLSearchParams(routing.search);
				cleanedParams.delete('ticket');
				const cleanedSearch = cleanedParams.toString() ? `?${cleanedParams.toString()}` : '';
				store.dispatch(routeChange({ ...routing, search: cleanedSearch }));
			}

			// 驗證現有的 Session Cookie
			try {
				await store.dispatch(getUserProcess());
				store.dispatch(setLogin());
			} catch {
				// Session 無效或未登入，不做任何處理
			}
			store.dispatch(setAuthChecking(false));
		}

		/**
		 * 基於 #2119 修復，客戶希望權限機制從 token 改為 httpOnly cookie 以後，還是主動刪除 token Ref:https://fox.25sprout.com/taikoo/taikoo_vespa/PM_taikoo_vespa/-/work_items/2137#note_1758417
		 */
		storage.clearAllToken();
		const children = await next();

		return children;
	},
	children: [
		{
			path: '',
			components: () => [import(/* webpackChunkName: 'home' */ './Home')],
			render: ([Home]) => <Home />,
			onEnter: async ({ next, store }) => {
				await store.dispatch(getBanner());
				await store.dispatch(fetchNews());
				await store.dispatch(fetchHomeModels());
				const children = await next();

				store.subscribe(async () => {
					if (timeoutId) {
						clearTimeout(timeoutId);
					}

					timeoutId = setTimeout(async () => {
						await store.dispatch(logout());
						store.dispatch(replaceRoute({ pathname: '/' }));
					}, 1800000);
				});

				return children;
			},
		},
		LoginRoute,
		SignupRoute,
		ResetRoute,
		VerifyRoute,
		VesShareRoute,
		OwnerShipRoute,
		MemberRoute,
		CheckRoute,
		NewsRoute,
		AfterSalesRoute,
		DisclaimerRoute,
		PrivacyRoute,
		MembershipTermsRoute,
		RegulationRoute,
		FaqRoute,
		ShopRoute,
		WebViewRoute,
		NotSupportRoute,
		TestDrivePrivacyPreviewRoute,
		AppointmentRoute,
	],
};

export default routes;
